import qs from 'qs'

// This is used to replace spaces in quoted values.
// The placeholder is removed at the end of the parsing process,
// just before the string gets encoded.
const SPACE_PLACEHOLDER = '___PEACH_SPACE___'

const key = {
  address: 'address',
  bankruptcycourtcase: 'bankruptcyCourtCase',
  bizemployeeemail: 'employeeEmail',
  bizemployeename: 'employeeName',
  bizemployeephone: 'employeePhone',
  bizname: 'businessName',
  borrowerid: 'id',
  borrowertype: 'borrowerType',
  caseid: 'caseId',
  city: 'city',
  dateofbirth: 'dateOfBirth',
  email: 'email',
  emailexact: 'emailExact',
  firstname: 'firstNamePartial',
  fullname: 'fullName',
  id: 'id',
  lastname: 'lastNamePartial',
  legalrepemail: 'legalRepEmail',
  legalrepfirstname: 'legalRepFirstName',
  legalreplastname: 'legalRepLastName',
  legalrepphone: 'legalRepPhone',
  accountid: 'loanId',
  accountidpartial: 'loanIdPartial',
  maidenname: 'maidenNamePartial',
  middlename: 'middleNamePartial',
  paymentmethod: 'paymentMethod',
  phone: 'phone',
  postalcode: 'postalCode',
  state: 'state',
  taxid: 'taxId',
  interactionid: 'interactionId',
}

type QueryObject = {
  [key: string]: string | undefined
}

/**
 *
 * This method will take any string that contains an even
 * set of quotes and return all quoted sets of substrings
 * without the quotes and will also replace empty spaces
 * inside any quoted sets with the URL-encoded %20 space
 * representation
 *
 * @param {String} str
 * @returns {String} will either return the input str or a new str
 */
const formatAllQuotedValues = (str: string) => {
  const hasQuotes = str.includes(`"`)

  if (!hasQuotes) return str

  const firstIndex = str.indexOf(`"`)
  const secondIndex = str.indexOf(`"`, str.indexOf(`"`) + 1)

  if (secondIndex === -1) return str

  const quotedValueWithQuotes = str.substring(firstIndex, secondIndex + 1)
  const quotedValue = quotedValueWithQuotes.replace(/"/g, '')
  const valueWithPlaceholder = quotedValue.replace(/ /g, SPACE_PLACEHOLDER)
  const newStr = str.replace(quotedValueWithQuotes, valueWithPlaceholder)
  return formatAllQuotedValues(newStr)
}

const _parseInput = (input: string) => {
  const hasTheWords: Array<string> = []
  const queryObject: QueryObject = {}

  /**
   * First, parse all search queries where its value is
   * wrapped within double quotes.
   */

  const formattedInput = formatAllQuotedValues(input)

  /**
   * Next, parse all other search queries
   */
  const searchQueries = formattedInput.split(' ')
  searchQueries.forEach((query) => {
    // Handle key/value search
    if (query.includes(':')) {
      const keyValue = query.split(':')
      const searchKey = keyValue[0].toLowerCase()
      const value = keyValue[1].replace(new RegExp(SPACE_PLACEHOLDER, 'g'), ' ')

      // Ignore invalid keys
      if (key[searchKey]) {
        queryObject[key[searchKey]] = value
      }
    } else {
      // Handle fuzzy search to dump into _hasTheWords
      hasTheWords.push(query)
    }
  })

  const hasTheWordsString = hasTheWords
    .map((w) => w.replace(new RegExp(SPACE_PLACEHOLDER, 'g'), ' '))
    .join(' ')

  if (hasTheWordsString.length > 0) {
    queryObject._hasTheWords = hasTheWordsString
  }

  return { queryObject }
}

const queryString = {
  toString: (input: string) => {
    const { queryObject } = _parseInput(input)
    return qs.stringify(queryObject)
  },
}

export default queryString

export const isKeyValid = (str) => !!key[str.toLowerCase()]
